<!-- <app-header-jm></app-header-jm> -->
<!--  -->
<!-- <div class="row IIFL_Dynamic_Class" [ngClass]="IsTransactionNew_Design ? 'IIFL_New_Design bg-white':''"> -->
<div [ngClass]="IsNewDesign ? 'IIFL_New_Design bg-white' : ''" class="row">
  <div class="col-12">
    <div class="w-100">
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-12 col-xs-12 InputBoxOuter"
          *ngIf="(UserType === '1' && !isCDR && isShowClientFilter) || 
          ((UserType === '2' || UserType === '3') && isShowClientFilter)"
        >
          <div class="CheckAgree">
            <label class="Cbx_container">
              <input
                type="radio"
                [checked]="FilterType == 'byClient'"
                name="RdbReportTypeEmp"
                value="byClient"
                (change)="onCheck('byClient')"
              />
              <span class="checkmark"></span>
              <label> Search by Investor </label>
            </label>
          </div>
        </div>
        <div
          [ngClass]="
            (UserType == '1' && isShowEmpSubBrokerFilter && !isCDR) || (UserType == '1' && isShowEmpSubBrokerFilter && !isShowClientFilter) ? 'd-flex' : 'd-none'
          "
          class="col-lg-3 col-md-4 col-sm-12 col-xs-12 InputBoxOuter"
        >
          <div class="CheckAgree">
            <label class="Cbx_container">
              <input
                type="radio"
                name="RdbReportTypeEmp"
                [checked]="FilterType == 'byEmpSubroker'"
                value="byEmpSubroker"
                (change)="onCheck('byEmpSubroker')"
              />
              <span class="checkmark"></span>
              <label> Search by Employee/Subbroker </label>
            </label>
          </div>
        </div>
        <div
          [ngClass]="
            (UserType == '1' && isShowHiearchyFilter && !isCDR ) || (UserType == '1' && isShowEmpSubBrokerFilter && !isShowClientFilter) ? 'd-flex' : 'd-none'
          "
          class="col-lg-3 col-md-4 col-sm-12 col-xs-12 InputBoxOuter BtmPad"
        >
          <div class="CheckAgree">
            <label class="Cbx_container">
              <input
                type="radio"
                name="RdbReportTypeEmp"
                [checked]="FilterType == 'byHierachy'"
                value="byHierachy"
                (change)="onCheck('byHierachy')"
              />
              <span class="checkmark"></span>
              <label> Search by Hierarchy </label>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 col-xs-12 InputBoxOuter BtmPad" 
        *ngIf="(IsAdminRolezero && IsFromReport && (isCDR || !isCDR) && UserType == '1' && ReportSource != 'FDReports' && isShowClientFilter) || (IsAdminRolezero && IsFromReport && UserType == '2' && ReportSource != 'FDReports' && isShowClientFilter) || (IsFromReport && isCDR && UserType == '1' && ReportSource != 'FDReports' && isShowClientFilter)">
        <div class="CheckAgree">
            <label class="Cbx_container">
              <input type="radio" id="Pans" [checked]="FilterType == 'ByPan'" name="RdbReportTypeEmp"
                (change)="MakeVisiblePan()" />
              <span class="checkmark"></span>
              <label for="Pans"> Search by PAN/UCC </label>
            </label>
          </div>
        </div>
        <div
          [ngClass]="
            (isShowClientFilter && UserType != '3' && IsShowUnmapedFilter && isCDR) ||  (isShowClientFilter && UserType != '3' && IsShowUnmapedFilter)
              ? 'd-flex'
              : 'd-none'
          "
          class="col-lg-3 col-md-4 col-sm-12 col-xs-12 InputBoxOuter"
        >
          <div class="CheckAgree">
            <label class="Cbx_container">
              <input
                type="radio"
                name="RdbReportTypeEmp"
                [checked]="FilterType == 'byUnmaped'"
                value="byUnmaped"
                (change)="onCheck('byUnmaped')"
              />
              <span class="checkmark"></span>
              <label> Search by Unmapped Investor </label>
            </label>
          </div>
        </div>

        <div class="btnClearOuter" [ngClass]="(this.ReportSource == 'portfolio-detailed-report' || this.ReportSource == 'portfolio-report-combine' || this.ReportSource == 'portfolio-report-redemption') ? 'd-block' : 'd-none'">
          <button class="btnClear" (click)="ClearFormData()">Clear All</button>
        </div>
      
      </div>
      
 
    </div>
    <form autocomplete="off" [formGroup]="clientFilterForm">
      <form autocomplete="off" [formGroup]="ClientDetails">
        <div
          class="row"
          [ngClass]="
            (IsAdminRolezero && ShowPan && IsFromReport && isCDR  && this.isShowClientFilter) || (IsAdminRolezero && ShowPan  && isCDR  && this.isShowClientFilter) ||
            (IsbyUnmaped && (UserType == '1' || UserType == '2')  && this.isShowClientFilter) || (ShowPan && IsFromReport && isCDR && this.isShowClientFilter) || (IsAdminRolezero && ShowPan && IsFromReport && this.isShowClientFilter)
              ? 'd-flex'
              : 'd-none'
          "
        >
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
            <div class="has-float-label">
              <input
                (keypress)="omit_special_char($event)"
                type="text"
                id="PANNo"
                formControlName="Pan"
                oninput="this.value = this.value.toUpperCase()"
                maxlength="12"
                class="form-control CommonTextBox TbxMarginBtm numandcharonly"
                placeholder="&nbsp;"
                [ngClass]="{
                  'is-invalid': ClientDetailsSubmitted && D.Pan.errors
                }"
                (blur) ="DisableShowReport()"
              />
              <label for="PANNo">PAN/UCC</label>
              <div
                *ngIf="ClientDetailsSubmitted && D.Pan.errors"
                class="invalid-feedback"
              >
                <div *ngIf="D.Pan.errors.required">PAN/UCC is required</div>
                <div *ngIf="D.Pan.errors.pattern">
                  Please enter valid PAN/UCC
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-1 col-md-3 col-sm-6 col-xs-12 InputBoxOuter text-center py-2"><strong>OR</strong></div>
          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
            <div class="has-float-label">
              <input
                (keypress)="omit_special_char($event)"
                type="text"
                id="CustId"
                oninput="this.value = this.value.toUpperCase()"
                formControlName="CustId"
                maxlength="10"
                class="form-control CommonTextBox TbxMarginBtm numandcharonly"
                placeholder="&nbsp;"
                [ngClass]="{
                  'is-invalid': ClientDetailsSubmitted && D.CustId.errors
                }"
              />
              <label for="CustId">Customer ID</label>
              <div
                *ngIf="ClientDetailsSubmitted && D.CustId.errors"
                class="invalid-feedback"
              >
                <div *ngIf="D.CustId.errors">Customer ID is required</div>
              </div>
            </div>
          </div> -->
          <div
            class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
          >
          <!-- *ngIf="!IsAdminRolezero" -->
            <button class="CommonSubmitButton mt-0" (click)="SearchClient()">
              Search Client
            </button>
          </div>
        </div>
      </form>

      <div class="row">
        <div
          class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
          [ngClass]="
            ChildSubbrokerData !== undefined &&
            UserType == '2' &&
            ChildSubbrokerData.length > 0 &&
            IsShowSubbroker
              ? 'd-block'
              : 'd-none'
          "
        >
          <div class="has-float-label">
            <select
              class="form-control CommonSelectBox TbxMarginBtm ChildSubbrokerSelect"
              formControlName="ChildSubbrokerId"
            >
              <option value="" disabled="true">Child Subbroker/RM Name</option>
              <option
                *ngFor="let item of ChildSubbrokerData"
                [value]="item.SubbrokerId"
              >
                {{ item.SubbrokerName }}
              </option>
            </select>
            <label>Child Subbroker/RM Name</label>
          </div>
        </div>

        <div
          class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
          [ngClass]="isdisplayFamilyName ? 'd-block' : 'd-none'"
        >
          <div class="has-float-label">
            <select
              data-placeholder="Select Family"
              class="form-control CommonSelectBox TbxMarginBtm FamilySelect"
              formControlName="FamilyId"
            >
              <option value="" disabled="true">Select Family</option>
              <option *ngFor="let item of FamilyData" [value]="item">
                {{ item }}
              </option>
            </select>
            <label>Family Name</label>
          </div>
        </div>
        <div
          class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
          [ngClass]="isDisplayClientName ? 'd-block' : 'd-none'"
        >
          <div class="has-float-label">
            <div
              [ngClass]="
                !isMultiSelect &&
                
                ReportSource != 'folio-master-report' &&
                ReportSource != 'Capital-Gain-Report' &&
                ReportSource != 'Opening-Closing-Report' &&
                ReportSource != 'Detailed-Holding-Report' &&
                ReportSource != 'IPO-NCD'&&
                ReportSource != 'dp-holding-report'
                  ? 'd-block'
                  : 'd-none'
              "
            >
              <select
                data-placeholder="Select Investor"
                class="form-control CommonSelectBox TbxMarginBtm ClientSelect"
                formControlName="ClientBasicInfoId"
              >
                <option value="" disabled="true" selected>
                  Select Investor
                </option>
                <option
                  *ngFor="let item of ClientData"
                  [value]="item.ClientBasicInfoId"
                >
                  {{ item.clientname }}
                </option>
              </select>
              <!-- <label>Investor Name</label> -->
            </div>
            <div
              [ngClass]="
                !isMultiSelect &&
                (
                 
                  ReportSource == 'folio-master-report' ||
                  ReportSource == 'Capital-Gain-Report' ||
                  ReportSource == 'Opening-Closing-Report' ||
                  ReportSource == 'Detailed-Holding-Report' ||
                  ReportSource == 'IPO-NCD' ||
                  ReportSource == 'dp-holding-report')
                  ? 'd-block'
                  : 'd-none'
              "
            >
              <ng-multiselect-dropdown-angular7
                [ngModelOptions]="{ standalone: true }"
                id="ddlClient"
                [placeholder]="'Select Investor Name'"
                [settings]="ClientDataSetting"
                [data]="ClientData"
                [(ngModel)]="selectedItems"
                (onSelect)="onSelectClientL($event)"
                (onDeSelect)="onSelectClientL($event, true)"
                (onSelectAll)="onItemSelectDeselectAll($event, 0)"
                (onDeSelectAll)="onItemSelectDeselectAll($event, 1)"
              >
              </ng-multiselect-dropdown-angular7>
            </div>

            <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
            <div [ngClass]="isMultiSelect ? 'd-block' : 'd-none'">
              <ng-multiselect-dropdown-angular7
                [ngModelOptions]="{ standalone: true }"
                id="ddlClient"
                [placeholder]="'Select Investor Name'"
                [data]="ClientData"
                [(ngModel)]="selectedItems"
                [settings]="ClientDataSetting"
                (onSelect)="onItemSelect($event)"
                (onDeSelect)="onItemSelect($event)"
                (onSelectAll)="onItemSelectDeselectAll($event, 0)"
                (onDeSelectAll)="onItemSelectDeselectAll($event, 1)"
                #ClientSelectNew
              >
              </ng-multiselect-dropdown-angular7>
            </div>
            <label>Investor Name</label>
          </div>
        </div>
      </div>

      <div class="w-100">
        <div class="w-100">
          <div class="row">
            <div
              class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
              [ngClass]="isDisplayEmployeeName ? 'd-block' : 'd-none'"
            >
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm EmployeeSelect"
                  formControlName="EmpId"
                  id="EmployeeId"
                >
                  <option value="" disabled="true">Select Employee</option>
                  <option
                    *ngFor="let item of EmployeeData"
                    [value]="item.EmpId"
                  >
                    {{ item.EmpFirstName }}
                  </option>
                </select>
                <label>Employee Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
              </div>
            </div>
            <div
              class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
              [ngClass]="isDisplaySubBrokerName ? 'd-block' : 'd-none'"
            >
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm SubbrokerSelect"
                  formControlName="SubbrokerId"
                  id="SubbrokerId"
                >
                  <option value="" disabled="true">Select Subbroker</option>
                  <option
                    *ngFor="let item of SubbrokerData"
                    [value]="item.SubbrokerId"
                  >
                    {{ item.SubbrokerName }}
                  </option>
                </select>
                <label>Subbroker Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
              </div>
            </div>
            <div
              class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
              [ngClass]="
                isDisplaySubBrokerName &&
                ChildSubbrokerData !== undefined &&
                ChildSubbrokerData.length > 0
                  ? 'd-block'
                  : 'd-none'
              "
            >
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm ChildSubbrokerSelect"
                  formControlName="ChildSubbrokerId"
                  id="ChildSubbrokerId"
                >
                  <option value="" disabled="true">
                    Child Subbroker/RM Name
                  </option>
                  <option
                    *ngFor="let item of ChildSubbrokerData"
                    [value]="item.SubbrokerId"
                  >
                    {{ item.SubbrokerName }}
                  </option>
                </select>
                <label>Child Subbroker/RM Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
              </div>
            </div>

            <div
              class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
              [ngClass]="isDisplayEmpSubBrokerFamilyName ? 'd-block' : 'd-none'"
            >
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm FamilySelect"
                  formControlName="FamilyId"
                >
                  <option value="" disabled="true">Select Family</option>
                  <option *ngFor="let item of FamilyData" [value]="item">
                    {{ item }}
                  </option>
                  <!-- <option *ngFor="let ClientBasicInfoId of EmpClientList" [value]="ClientBasicInfoId.VALUEFIELD">
                {{ClientBasicInfoId.TEXTFIELD}}</option> -->
                </select>
                <label>Family Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
              </div>
            </div>
            <div
              class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
              [ngClass]="isDisplayEmpSubClientName ? 'd-block' : 'd-none'"
            >
              <div class="has-float-label">
                <div [ngClass]="isMultiSelect ? 'd-none' : 'd-block'">
                  <select
                    class="form-control CommonSelectBox TbxMarginBtm ClientSelect"
                    formControlName="ClientBasicInfoId"
                    id="InvestorSelect"
                  >
                    <option value="" disabled="true">Select Investor</option>
                    <option
                      *ngFor="let item of ClientData"
                      [value]="item.ClientBasicInfoId"
                    >
                      {{ item.clientname }}
                    </option>
                    <!-- <option *ngFor="let ClientBasicInfoId of EmpClientList" [value]="ClientBasicInfoId.VALUEFIELD">
                {{ClientBasicInfoId.TEXTFIELD}}</option> -->
                  </select>
                  <!-- <label>Investor Name</label> -->
                </div>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
                <div [ngClass]="isMultiSelect ? 'd-block' : 'd-none'">
                  <ng-multiselect-dropdown-angular7
                    [ngModelOptions]="{ standalone: true }"
                    id="ddlClient"
                    [placeholder]="'Select Investor Name'"
                    [data]="ClientData"
                    [(ngModel)]="selectedItems"
                    [settings]="ClientDataSetting"
                    (onSelect)="onItemSelect($event)"
                    (onDeSelect)="onItemSelect($event)"
                    (onSelectAll)="onItemSelectDeselectAll($event, 0)"
                    (onDeSelectAll)="onItemSelectDeselectAll($event, 1)"
                  >
                  </ng-multiselect-dropdown-angular7>
                </div>
                <label>Investor Name</label>
              </div>
            </div>
          </div>
          <div
            class="row"
            [ngClass]="
              FilterType == 'byHierachy' && UserType == '1'
                ? 'd-flex'
                : 'd-none'
            "
          >
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm HierarchySelect"
                  formControlName="HierarchyId"
                >
                  <option value="" disabled="true">Select Hierarchy</option>
                  <option
                    *ngFor="let item of HierarchyData"
                    [value]="item.HierarchyName"
                  >
                    {{ item.HierarchyName }}
                  </option>
                </select>
                <label>Hierarchy Name</label>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm PlaceSelect"
                  formControlName="PlaceId"
                >
                  <option value="" disabled="true">Select Entity</option>
                  <option
                    *ngFor="let item of PlaceDataALL"
                    [value]="item.PlaceName"
                  >
                    {{ item.PlaceName }}
                  </option>
                </select>
                <label>Entity Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm EmployeeSelect"
                  formControlName="EmpId"
                >
                  <option value="" disabled="true">Select Employee</option>
                  <option
                    *ngFor="let item of EmployeeDataH"
                    [value]="item.EmpId"
                  >
                    {{ item.EmpFirstName }}
                  </option>
                </select>
                <label>Employee Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
            <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
            </div>
          </div> -->
              </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter">
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm SubbrokerSelect"
                  formControlName="SubbrokerId"
                >
                  <option value="" disabled="true">Select Subbroker</option>
                  <option
                    *ngFor="let item of SubbrokerData"
                    [value]="item.SubbrokerId"
                  >
                    {{ item.SubbrokerName }}
                  </option>
                  <!-- <option *ngFor="let ClientBasicInfoId of EmpClientList" [value]="ClientBasicInfoId.VALUEFIELD">
                {{ClientBasicInfoId.TEXTFIELD}}</option> -->
                </select>
                <label>Subbroker Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
              </div>
            </div>
            <div
              class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
              [ngClass]="
                ChildSubbrokerData !== undefined &&
                ChildSubbrokerData.length > 0
                  ? 'd-block'
                  : 'd-none'
              "
            >
              <div class="has-float-label">
                <select
                  class="form-control CommonSelectBox TbxMarginBtm ChildSubbrokerSelect"
                  formControlName="ChildSubbrokerId"
                >
                  <option value="" disabled="true">
                    Child Subbroker/RM Name
                  </option>
                  <option
                    *ngFor="let item of ChildSubbrokerData"
                    [value]="item.SubbrokerId"
                  >
                    {{ item.SubbrokerName }}
                  </option>
                </select>
                <label>Child Subbroker/RM Name</label>
                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
              </div>
            </div>
            <div
              class="col-lg-3 col-md-3 col-sm-6 col-xs-12 InputBoxOuter"
              *ngIf="HierarchyClient"
            >
              <div class="has-float-label">
                <div [ngClass]="isMultiSelect ? 'd-none' : 'd-block'">
                  <select
                    class="form-control CommonSelectBox TbxMarginBtm ClientSelect"
                    formControlName="ClientBasicInfoId"
                  >
                    <option value="" disabled="true">Select Investor</option>
                    <option
                      *ngFor="let item of ClientData"
                      [value]="item.ClientBasicInfoId"
                    >
                      {{ item.clientname }}
                    </option>
                    <!-- <option *ngFor="let ClientBasicInfoId of EmpClientList" [value]="ClientBasicInfoId.VALUEFIELD">
                {{ClientBasicInfoId.TEXTFIELD}}</option> -->
                  </select>
                  <!-- <label>Investor Name</label> -->
                </div>

                <!-- <div *ngIf="l.ClientBasicInfoId.errors" class="invalid-feedback">
              <div *ngIf="l.ClientBasicInfoId.errors.required">Please select client
              </div>
            </div> -->
                <div [ngClass]="isMultiSelect ? 'd-block' : 'd-none'">
                  <ng-multiselect-dropdown-angular7
                    [ngModelOptions]="{ standalone: true }"
                    id="ddlClient"
                    [placeholder]="'Select Investor Name'"
                    [data]="ClientData"
                    [(ngModel)]="selectedItems"
                    [settings]="ClientDataSetting"
                    (onSelect)="onItemSelect($event)"
                    (onDeSelect)="onItemSelect($event)"
                    (onSelectAll)="onItemSelectDeselectAll($event, 0)"
                    (onDeSelectAll)="onItemSelectDeselectAll($event, 1)"
                  >
                  </ng-multiselect-dropdown-angular7>
                </div>
                <label>Investor Name</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>



<div class="modal" id="DisableTranAlertModalNew" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Welcome</div>
      <div class="modal-body AlertModalBody">
        <span>
          Please complete customer profile to enable online MF transactions.
        </span>
      </div>
      <div class="modal-footer AlertModalFooter">
        <button
          type="button"
          data-dismiss="modal"
          class="CursorPointer"
          (click)="GoToClientProfile()"
        >
          Complete Profile
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="AlertModal_Reload" data-backdrop="static" data-keyboard="false" appDisabledRightClick>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content AlertModalContentCls">
      <div class="modal-header AlertModalHeader">Important Message</div>
      <div id="AlertModalContent_Reload" class="modal-body AlertModalBody"></div>
      <div class="modal-footer AlertModalFooter">
        <button type="button" data-dismiss="modal" (click)="ReloadPage()" class="CursorPointer">Okay</button>
      </div>
    </div>
  </div>
</div>